import axios from "axios";
import { getToken, getUser } from "../Utils/Common";
import token_valid from "./TokenValid";

///////////// production /////////////////////////////////

//get production data by paging
const getExportProductionDataByPaging = async (offset, pageSize, filter) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    return axios
      .post(
        process.env.REACT_APP_API_URL +
          "/api/export/production/all/" +
          offset +
          "/" +
          pageSize,
        {
          barcode: filter._barcode ? filter._barcode.trim() : null,
          productName: filter._productName ? filter._productName.trim() : null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log(response);
        console.log("Response --", response.data.content);
        return response.data;
      })
      .catch(async (error) => {
        console.log("Get export production " + error);
        return "Something went wrong...";
      });
  }
};

const addProduction = async (productionValues) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    const productionBody = {
      productId: parseInt(productionValues._productId),
      productionQty: parseInt(productionValues._productionQty),
      electricityCost: parseFloat(productionValues._electricityCost) || 0,
      labourCost: parseFloat(productionValues._labourCost) || 0,
      transportCost: parseFloat(productionValues._transportCost) || 0,
      otherCost: parseFloat(productionValues._otherCost) || 0,
      packingCost: parseFloat(productionValues._packingCost) || 0,
      packingPersonId: productionValues._packingPersonId || null,
      addedBy: productionValues._addedBy || getUser().email,
      items: productionValues._productionItems,
      note: productionValues._productionNoteNote || "",
      useStandardBOM: productionValues._useStandardBOM,
      bomVersion: productionValues._bomVersion,
    };

    console.log("Sending production body:", productionBody);

    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/export/production/add",
        productionBody,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log("Production added successfully:", response);
        return { success: true, data: response.data };
      })
      .catch((error) => {
        console.error("Add production error:", error);
        console.error("Error response:", error.response);

        // Handle insufficient material stock error (400 or 500)
        if (error.response && error.response.data) {
          const errorData = error.response.data;

          console.log("Error data:", errorData);

          if (
            errorData.error === "INSUFFICIENT_MATERIAL_STOCK" ||
            errorData.insufficientMaterials
          ) {
            return {
              success: false,
              error: "INSUFFICIENT_STOCK",
              insufficientMaterials: errorData.insufficientMaterials,
              message:
                errorData.message ||
                "Insufficient material stock for production",
            };
          }
        }

        return {
          success: false,
          error: "UNKNOWN_ERROR",
          message: error.response?.data?.message || "Something went wrong",
        };
      });
  }
};

//get recent production record according to the product Id
const getLatestProductionByProductId = async (productId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/export/production/get_last_production/" +
          productId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("get production " + error);
        return "Something went wrong...";
      });
  }
};

//get productions for sales
const getProductionsForSales = async (productId, requiredQty) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/export/production/sale/" +
          productId +
          "/" +
          requiredQty,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("get production for sale" + error);
        return "Something went wrong...";
      });
  }
};

//get production by id
const getProductionById = async (productionId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/export/production/" +
          productionId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("get production " + error);
        return "Something went wrong...";
      });
  }
};

// Send a DRAFT production for approval (notifies approvers)
const sendProductionForApproval = async (productionId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/export/production/send-approval/" +
          productionId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then(() => {
        return { success: true };
      })
      .catch((error) => {
        console.log("Send production for approval " + error);
        return {
          success: false,
          message:
            error.response?.data?.message ||
            "Unable to send production for approval",
        };
      });
  }
};

// Approve (isApproved=true) or reject (false) a production awaiting approval
const approveProduction = async (productionId, isApproved) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/export/production/approve/" +
          productionId +
          "/" +
          isApproved,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then(() => {
        return { success: true };
      })
      .catch((error) => {
        console.log("Approve or reject production " + error);

        // Approving consumes the materials, so it can fail on stock that has been
        // used elsewhere since the draft was raised.
        const errorData = error.response?.data;
        if (errorData?.insufficientMaterials?.length > 0) {
          return {
            success: false,
            error: "INSUFFICIENT_STOCK",
            insufficientMaterials: errorData.insufficientMaterials,
            message:
              errorData.message || "Insufficient material stock for production",
          };
        }

        return {
          success: false,
          message:
            errorData?.message ||
            `Unable to ${isApproved ? "approve" : "reject"} production`,
        };
      });
  }
};

// Delete a DRAFT or REJECTED production (returns reserved materials for a draft)
const deleteProduction = async (productionId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .delete(
        process.env.REACT_APP_API_URL +
          "/api/export/production/" +
          productionId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then(() => {
        return { success: true };
      })
      .catch((error) => {
        console.log("Delete production " + error);
        return {
          success: false,
          message:
            error.response?.data?.message || "Unable to delete production",
        };
      });
  }
};

// Get last 5 productions by barcode
const getLast5ProductionsByBarcode = async (barcode) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/export/production/barcode/" +
          barcode +
          "/last-five",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log("Last 5 productions by barcode:", response);
        return response.data;
      })
      .catch((error) => {
        console.log("get last 5 productions by barcode error: " + error);
        return "Something went wrong...";
      });
  }
};

//////////////////////////////////////////////////////////

// UPDATED: Removed 'items' from filter
const getExportProducts = async (offset, pageSize, filter) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL +
          "/api/export/product/all/" +
          offset +
          "/" +
          pageSize,
        {
          barcode: filter._barcode ? filter._barcode.trim() : null,
          productName: filter._product ? filter._product.trim() : null,
          addedBy: filter._addedBy ? filter._addedBy.trim() : null,
          categories:
            filter._categories.length !== 0 ? filter._categories : null,
          // REMOVED: items filter (materials now managed via ProductionMaterials)
          status: filter._status ? filter._status.trim() : null,
          warehouseType: filter._type ? filter._type.trim() : null,
          warehouseId: filter._warehouseId ? filter._warehouseId : null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        return "Something went wrong...";
      });
  }
};

//////////////////export products /////////////////////////
//check barcode
const checkBarcode = async (barcode) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/export/product/check/barcode/" +
          barcode,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("check barcode " + error);
        return "Something went wrong...";
      });
  }
};

// UPDATED: Removed 'items' from product body
const addExportProduct = async (values) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    let user = getUser();

    return axios
      .post(process.env.REACT_APP_API_URL + "/api/export/product/add", values, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then(async (response) => {
        console.log(response);
        return true;
      })
      .catch((error) => {
        console.log("add export product " + error);
        return false;
      });
  }
};

//Product bulk update
const productBulkUpdate = async (formData) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/export/product/bulk-import",
        formData,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        },
      )
      .then(async (response) => {
        console.log(response);
        return "Success";
      })
      .catch((error) => {
        console.log("product bulk update " + error);
        return "Something went wrong...";
      });
  }
};

//update export product
const updateExportProduct = async (values, productId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    let user = getUser();

    return axios
      .put(
        process.env.REACT_APP_API_URL + "/api/export/product/" + productId,
        values,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then(async (response) => {
        console.log(response);
        return true;
      })
      .catch((error) => {
        console.log("update export product " + error);
        return false;
      });
  }
};

//find export Product by id
const getExportProductById = async (productId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/export/product/" + productId, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("get export product by id " + error);
        return "Something went wrong...";
      });
  }
};

//get products by category
const getExportProductsByCategory = async (cat_id) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/export/product/find/category/" +
          cat_id,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("get export products by category " + error);
        return "Something went wrong...";
      });
  }
};

///////////////////////////////////////////////////////////

/////////////////////////// Production Materials (BOM) //////////////////////

// Get active materials for a product barcode
const getActiveMaterialsByBarcodeId = async (barcodeId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/production/materials/barcode/" +
          barcodeId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("get active materials " + error);
        return "Something went wrong...";
      });
  }
};

// Get all materials (including inactive) for a product barcode
const getAllMaterialsByBarcodeId = async (barcodeId) => {
  console.log("Getting all materials for barcode ID:", barcodeId);
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/product/barcode/" +
          barcodeId +
          "/all",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("get all materials " + error);
        return "Something went wrong...";
      });
  }
};

// Add a single material to BOM
const addProductionMaterial = async (materialBody) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/production/materials/add",
        materialBody,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("add production material " + error);
        return false;
      });
  }
};

// Bulk add/update materials
const bulkAddProductionMaterials = async (bulkBody) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/production/materials/bulk",
        bulkBody,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log(response);
        return true;
      })
      .catch((error) => {
        console.log("bulk add materials " + error);
        return false;
      });
  }
};

// Update a material
const updateProductionMaterial = async (materialId, materialBody) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .put(
        process.env.REACT_APP_API_URL +
          "/api/production/materials/" +
          materialId,
        materialBody,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("update production material " + error);
        return false;
      });
  }
};

// Delete a material
const deleteProductionMaterial = async (materialId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .delete(
        process.env.REACT_APP_API_URL +
          "/api/production/materials/" +
          materialId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log(response);
        return true;
      })
      .catch((error) => {
        console.log("delete production material " + error);
        return false;
      });
  }
};

// Get current BOM version
const getCurrentBOMVersion = async (barcodeId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/production/materials/barcode/" +
          barcodeId +
          "/current-version",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("get current BOM version " + error);
        return 1;
      });
  }
};

///////////////////////////////////////////////////////////

/////////////////////////// category //////////////////////
//get export category data with pagination
const getExportCategoryData = async (offset, pageSize, filter) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL +
          "/api/export/category/search/" +
          offset +
          "/" +
          pageSize,
        {
          category: filter._category ? filter._category.trim() : null,
          subCat_1: filter._subCat_1 ? filter._subCat_1.trim() : null,
          subCat_2: filter._subCat_2 ? filter._subCat_2.trim() : null,
          subCat_3: filter._subCat_3 ? filter._subCat_3.trim() : null,
          subCat_4: filter._subCat_4 ? filter._subCat_4.trim() : null,
          subCat_5: filter._subCat_5 ? filter._subCat_5.trim() : null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("get Export Category: " + error);
        return "Something went wrong...";
      });
  }
};

//get all categories
const getAllCategories = async () => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/export/category/all", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("get all categories " + error);
        return "Something went wrong...";
      });
  }
};

//check category availability
const checkCategory = async (values) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/export/category/check",
        {
          category: values._exportMCategory.trim(),
          subCat_1: values._subCat_1.trim(),
          subCat_2: values._subCat_2.trim(),
          subCat_3: values._subCat_3.trim(),
          subCat_4: values._subCat_4.trim(),
          subCat_5: values._subCat_5.trim(),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then(async (response) => {
        console.log("Category", response.data);
        return response.data;
      })
      .catch((error) => {
        console.log("check category error: " + error);
        return "Something went wrong...";
      });
  }
};

//add new category
const addNewCategory = async (values) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/export/category/add",
        {
          category: values._exportMCategory.trim(),
          subCat_1: values._subCat_1.trim(),
          subCat_2: values._subCat_2.trim(),
          subCat_3: values._subCat_3.trim(),
          subCat_4: values._subCat_4.trim(),
          subCat_5: values._subCat_5.trim(),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then(async (response) => {
        console.log("Response", response.data);
        return response.data;
      })
      .catch((error) => {
        console.log("add category " + error);
        return "Something went wrong...";
      });
  }
};

//get categories by category id
const getExCategoryById = async (cat_id) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(process.env.REACT_APP_API_URL + "/api/export/category/" + cat_id, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("get category by id " + error);
        return "Something went wrong...";
      });
  }
};

//get Export Category data with pagination by filtering
const getExCategoryDataByFilter = async (offset, pageSize, filter) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    return axios
      .post(
        process.env.REACT_APP_API_URL +
          "/api/export/category/search/" +
          offset +
          "/" +
          pageSize,
        {
          category: filter._category ? filter._category.trim() : null,
          subCat_1: filter._subCat_1 ? filter._subCat_1.trim() : null,
          subCat_2: filter._subCat_2 ? filter._subCat_2.trim() : null,
          subCat_3: filter._subCat_3 ? filter._subCat_3.trim() : null,
          subCat_4: filter._subCat_4 ? filter._subCat_4.trim() : null,
          subCat_5: filter._subCat_5 ? filter._subCat_5.trim() : null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch(async (error) => {
        console.log("get ex Categories by filter " + error);
        return "Something went wrong...";
      });
  }
};

const getProductBarcodes = async (offset, pageSize, filter) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL +
          "/api/product/barcode/all/" +
          offset +
          "/" +
          pageSize,
        {
          barcode: filter._barcode ? filter._barcode.trim() : null,
          productName: filter._product ? filter._product.trim() : null,
          addedBy: filter._addedBy ? filter._addedBy.trim() : null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("get product barcodes error: " + error);
        return "Something went wrong...";
      });
  }
};

// NEW: Get product barcode by ID (for view page)
const getProductBarcodeById = async (barcodeId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL + "/api/product/barcode/" + barcodeId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("get product barcode by id error: " + error);
        return "Something went wrong...";
      });
  }
};

const createNewBOMVersion = async (barcodeId, materialsBody) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL +
          `/api/production/materials/barcode/${barcodeId}/new-version`,
        materialsBody,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((response) => {
        console.log("New BOM version created:", response);
        return response.data;
      })
      .catch((error) => {
        console.log("create new BOM version error: " + error);
        return "Something went wrong...";
      });
  }
};

///////////////////////////////////////////////////////////

export {
  addProduction,
  addExportProduct,
  checkBarcode,
  getExportCategoryData,
  getExportProductById,
  getExportProductsByCategory,
  getExportProducts,
  addNewCategory,
  getAllCategories,
  checkCategory,
  getExCategoryById,
  getExCategoryDataByFilter,
  updateExportProduct,
  getLatestProductionByProductId,
  getExportProductionDataByPaging,
  getProductionById,
  getProductionsForSales,
  productBulkUpdate,
  // NEW: Production Materials (BOM) exports
  getActiveMaterialsByBarcodeId,
  getAllMaterialsByBarcodeId,
  addProductionMaterial,
  bulkAddProductionMaterials,
  updateProductionMaterial,
  deleteProductionMaterial,
  getCurrentBOMVersion,
  getProductBarcodes,
  getProductBarcodeById,
  createNewBOMVersion,
  getLast5ProductionsByBarcode,
  sendProductionForApproval,
  approveProduction,
  deleteProduction,
};
